import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { Button } from '@chakra-ui/react'
import { wwtMemo } from '@wwt/custom/wwt'

import { wwtPerformanceLog } from '@wwt/core/admin'
import { PhoneInfo } from '@wwt/entities/api/search-response'

import { cn } from '@/shared/lib/cn'
import { UnderDevelopment } from '@/shared/ui/UnderDevelopment'

interface ReservationTabContactPropertyProps {
	phones?: PhoneInfo[]
	email?: string
	children?: ReactNode
	className?: string
}

/**
 *
 *
 * @author Ivan Shchedrovskyi
 */
export const ReservationTabContactProperty = wwtMemo(
	({
		phones,
		email,
		className,
		children
	}: ReservationTabContactPropertyProps) => {
		const { t } = useTranslation('room-page', {
			keyPrefix: 'reservationTab.contactProperty'
		})

		wwtPerformanceLog('ReservationTabContactProperty')

		return (
			<section className={cn('flex flex-col gap-y-6', className)}>
				<h2 className="ts-headline-4">{t('title')}</h2>

				<div className="flex flex-col gap-y-6">
					{phones?.map(phone => (
						<Link
							key={phone.description + phone.phoneNumber}
							className="ts-hyperlink-button-2 decoration-skip-ink-none text-primary-100 lowercase underline decoration-2 first-letter:uppercase hover:text-gray-300"
							to={`tel:${phone.phoneNumber}`}
						>
							<span>{phone.description}</span>
							{': '}
							<span>{phone.phoneNumber}</span>
						</Link>
					))}

					{email && (
						<Link
							className="ts-hyperlink-button-2 decoration-skip-ink-none text-primary-100 underline decoration-2 hover:text-gray-300"
							to={`mailto:${email}`}
						>
							{t('email', { email })}
						</Link>
					)}

					<UnderDevelopment asChild>
						<Button
							justifyContent="left"
							variant="link"
							fontWeight="medium"
							fontSize={{ base: 'sm', md: 'md' }}
							color="primary.100"
							isDisabled
							textUnderlineOffset={4}
						>
							{t('sendMessage')}
						</Button>
					</UnderDevelopment>

					{children}
				</div>
			</section>
		)
	}
)
